//Stateler çekilip return edilecek
export const getLoading = (state) => {
    return state.loading
}

export const getCustomerInfo = (state) => {
    return state.customerStatus
}

export const getCustomerData = (state) => {
    return state.customerData
}

export const getCustomerAddresses = (state) => {
    return state.customerAddressData
}

export const getCustomerAddressInfo = (state) => {
    return state.customerAddressInfo
}

export const getCustomerContactInfo = (state) => {
    return state.customerContactInfo
}

export const getCustomerContacts = (state) => {
    return state.customerContactData
}

export const customerList = (state) => {
    return state.customers
}

export const getCustomerPageInfo = (state) => {
    return state.customerPageInfo
}

export const getCustomerSubscriptions= (state) => {
    return state.customerSubscriptions
}

export const getCustomerSubsInfo= (state) => {
    return state.customerSubsInfo
}
export const getCustomerCompanyInfo = (state) => {
    return state.customerCompanyInfo
}

export const getCustomerCompany = (state) => {
    return state.customerCompanyData
}

export const getCustomerProducts = (state) => {
    return state.customerProducts
}

export const getApprovalHistory = (state) => {
    return state.approvalHistory
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Customer/Getters.js